class ShopByType {
  constructor(section) {
    this.section = section;
    const id = section.dataset.sectionId;
    this.track = document.getElementById(`shop-by-type-track-${id}`);
    this.scrollbar = document.getElementById(`shop-by-type-scrollbar-${id}`);
    this.thumb = document.getElementById(`shop-by-type-thumb-${id}`);
    if (!this.track || !this.scrollbar || !this.thumb) return;

    this.onTrackScroll = this.onTrackScroll.bind(this);
    this.onThumbPointerDown = this.onThumbPointerDown.bind(this);
    this.onThumbPointerMove = this.onThumbPointerMove.bind(this);
    this.onThumbPointerUp = this.onThumbPointerUp.bind(this);
    this.onTrackPointerDown = this.onTrackPointerDown.bind(this);

    this.track.addEventListener('scroll', this.onTrackScroll, { passive: true });
    this.thumb.addEventListener('pointerdown', this.onThumbPointerDown);
    this.scrollbar.addEventListener('pointerdown', this.onTrackPointerDown);
    window.addEventListener('resize', () => this.refresh());

    this.refresh();
  }

  refresh() {
    const maxScroll = this.track.scrollWidth - this.track.clientWidth;
    const overflows = maxScroll > 1;

    this.scrollbar.classList.toggle('is-visible', overflows);
    if (!overflows) return;

    const thumbWidthRatio = this.track.clientWidth / this.track.scrollWidth;
    this.thumb.style.width = `${Math.max(thumbWidthRatio * 100, 12)}%`;

    this.updateThumbPosition();
  }

  onTrackScroll() {
    this.updateThumbPosition();
  }

  updateThumbPosition() {
    const maxScroll = this.track.scrollWidth - this.track.clientWidth;
    if (maxScroll <= 0) return;

    const scrollRatio = this.track.scrollLeft / maxScroll;
    const trackWidth = this.scrollbar.clientWidth;
    const thumbWidth = this.thumb.offsetWidth;
    const maxThumbOffset = trackWidth - thumbWidth;

    this.thumb.style.left = `${scrollRatio * maxThumbOffset}px`;
  }

  onThumbPointerDown(event) {
    event.preventDefault();
    this.dragStartX = event.clientX;
    this.dragStartLeft = this.thumb.offsetLeft;
    this.thumb.setPointerCapture(event.pointerId);
    window.addEventListener('pointermove', this.onThumbPointerMove);
    window.addEventListener('pointerup', this.onThumbPointerUp);
  }

  onThumbPointerMove(event) {
    const delta = event.clientX - this.dragStartX;
    const trackWidth = this.scrollbar.clientWidth;
    const thumbWidth = this.thumb.offsetWidth;
    const maxThumbOffset = trackWidth - thumbWidth;

    let newLeft = this.dragStartLeft + delta;
    newLeft = Math.max(0, Math.min(maxThumbOffset, newLeft));

    const ratio = maxThumbOffset > 0 ? newLeft / maxThumbOffset : 0;
    const maxScroll = this.track.scrollWidth - this.track.clientWidth;

    this.track.scrollLeft = ratio * maxScroll;
  }

  onThumbPointerUp() {
    window.removeEventListener('pointermove', this.onThumbPointerMove);
    window.removeEventListener('pointerup', this.onThumbPointerUp);
  }

  // Clicking anywhere on the scrollbar track jumps the thumb there
  onTrackPointerDown(event) {
    if (event.target === this.thumb) return;

    const rect = this.scrollbar.getBoundingClientRect();
    const clickX = event.clientX - rect.left;
    const thumbWidth = this.thumb.offsetWidth;
    const maxThumbOffset = rect.width - thumbWidth;

    let newLeft = clickX - thumbWidth / 2;
    newLeft = Math.max(0, Math.min(maxThumbOffset, newLeft));

    const ratio = maxThumbOffset > 0 ? newLeft / maxThumbOffset : 0;
    const maxScroll = this.track.scrollWidth - this.track.clientWidth;

    this.track.scrollTo({ left: ratio * maxScroll, behavior: 'smooth' });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.shop-by-type').forEach((section) => {
    new ShopByType(section);
  });
});